import { ShiftPeriodNavigatorControl } from "@dexteel/mesf-core";
import { Grid, Paper, makeStyles } from "@material-ui/core";
import { get } from "lodash-es";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDebounce } from "use-debounce";
import { useLogbookContext } from "../../context/logbookContext";
import { getEntries } from "../../repository/LogbookRepository";
import { SearchFilter } from "./searchFilter";

const customPeriodOptions = [
	{ value: "Day", label: "Day" },
	{ value: "4Days", label: "4 Days" },
	{ value: "Week", label: "Week" },
	{ value: "Month", label: "Month" },
];

export const Filters = () => {
	const navigate = useNavigate();

	const {
		state: {
			FilterParameters: { AssetId, SearchShiftParameters, SearchText },
		},
		actions: {
			setFilterSearchShiftParameters,
			setFilterSearchText,
			setEntriesList,
			setLoadingTable,
		},
	} = useLogbookContext();

	const [debouncedSearchText] = useDebounce(SearchText, 400);

	useEffect(() => {
		navigate("/logbook-report");
	}, [SearchShiftParameters, debouncedSearchText]);

	useEffect(() => {
		let isValid = true;
		const getData = async () => {
			setLoadingTable(true);
			const res = await getEntries(
				null,
				debouncedSearchText,
				AssetId,
				SearchShiftParameters?.StartShiftId || null,
				SearchShiftParameters?.EndShiftId || null,
			);

			if (isValid && res.ok) {
				const rowsSource = get(res, "data.tables[0]", []);
				setEntriesList(rowsSource.rows);
			}
			setLoadingTable(false);
		};

		getData();

		return () => {
			isValid = false;
		};
	}, [SearchShiftParameters, debouncedSearchText]);

	return (
		<Paper elevation={1} style={{ padding: 8 }}>
			<Grid container spacing={0}>
				<Grid item xs={12}>
					<ShiftPeriodNavigatorControl
						onChange={setFilterSearchShiftParameters}
						value={SearchShiftParameters}
						showShiftAndCrews={false}
						dateFormat="MM/DD/YYYY"
						periodOptions={customPeriodOptions}
					/>
				</Grid>
				<Grid item xs={12}>
					<SearchFilter value={SearchText} onChange={setFilterSearchText} />
				</Grid>
			</Grid>
		</Paper>
	);
};
